import { Alert, VFlow } from 'bold-ui'

import { MChatRfResultadoView } from '../../components/MChatRfResultadoView'
import { MChatRiscoPrevioRelevanteInfoModel } from '../../mchat/model-mchat'
import { MCHAT_RESULTADOS } from '../../model-mChatRf'
import { ConsultaSeguimentoViewModel } from '../model-consultaSeguimento'
import { getResultadoLabel } from '../utils-consultaSeguimento'

interface ConsultaSeguimentoResultadoViewProps {
  value: ConsultaSeguimentoViewModel
  alertaConsultaSeguimentoAnterior?: MChatRiscoPrevioRelevanteInfoModel
  isConsultaSeguimentoDesatualizada?: boolean
}

export function ConsultaSeguimentoResultadoView(props: Readonly<ConsultaSeguimentoResultadoViewProps>) {
  const { value, alertaConsultaSeguimentoAnterior, isConsultaSeguimentoDesatualizada = false } = props

  if (!value.resultado) return null

  const { status, title, encaminhamento } = MCHAT_RESULTADOS[value.resultado]

  const label = getResultadoLabel(value, isConsultaSeguimentoDesatualizada)

  return (
    <VFlow vSpacing={0}>
      <MChatRfResultadoView
        status={isConsultaSeguimentoDesatualizada ? 'default' : status}
        title={isConsultaSeguimentoDesatualizada ? 'Resultado desatualizado' : title}
        description={isConsultaSeguimentoDesatualizada ? null : encaminhamento()}
        label={label}
        footerInfo={value.footerInfo}
        alertaConsultaSeguimentoAnterior={alertaConsultaSeguimentoAnterior}
      />
      {isConsultaSeguimentoDesatualizada && (
        <Alert type='danger'>
          <strong>Edição obrigatória:</strong> Foi alterado o resultado do M-Chat-R e é necessário editar a avaliação da
          Entrevista de seguimento.
        </Alert>
      )}
    </VFlow>
  )
}
